import { StepOne } from './step-one'
import { StepThree } from './step-three'
import { StepTwo } from './step-two'
import { useStepperStore } from './stepper'

export const StepsContent = () => {
  const { activeStep } = useStepperStore()

  return (
    <>
      {activeStep === 0 && <StepOne />}
      {activeStep === 1 && <StepTwo />}
      {activeStep === 2 && <StepThree />}
    </>
  )
}
